const SUBSCRIPTION_CONFIG_KEY = 'ApiResource:SubscriptionApi:Url';

export const FETCH_CURRENT_SUBSCRIPTION_QUERY_KEY = [SUBSCRIPTION_CONFIG_KEY, 'getCurrent'];

export const FETCH_SUBSCRIPTION_SERVICE_STATUS_QUERY_KEY = [SUBSCRIPTION_CONFIG_KEY, 'getStatus'];

export const FETCH_SUBSCRIPTION_USERS_QUERY_KEY = (subscriptionName: string) => [
  SUBSCRIPTION_CONFIG_KEY,
  'getSubscriptionUsers',
  subscriptionName
];

export const FETCH_USER_PERMISSIONS_QUERY_KEY = [SUBSCRIPTION_CONFIG_KEY, 'getPermissions'];

export const FETCH_SUBSCRIPTION_USERS_PERMISSIONS_QUERY_KEY = (subscriptionId: number | undefined) => [
  SUBSCRIPTION_CONFIG_KEY,
  'getSubscriptionUsersPermissions',
  subscriptionId
];
